export interface Article {
  id: string;
  categoryId: string;
  title: string;
  summary: string;
  content: string;
  coverImage: string;
  author: string;
  publishDate: string;
  views: number;
  tags: string[];
  isFeatured: boolean;
}

export const articles: Article[] = [
  {
    id: "article-1",
    categoryId: "cat-1",
    title: "皇马2-1逆转巴萨！贝林厄姆梅开二度，国家德比再现经典",
    summary: "西甲联赛第30轮焦点战，皇家马德里在伯纳乌球场凭借贝林厄姆的两粒进球，以2-1逆转战胜巴塞罗那，继续保持联赛领先优势。",
    content: `<p>北京时间2026年8月3日凌晨，西甲联赛第30轮迎来万众瞩目的西班牙国家德比，皇家马德里坐镇伯纳乌球场迎战巴塞罗那。这是一场关乎联赛冠军归属的关键战役。</p>
    <p>比赛开始后，巴萨率先发难。第15分钟，莱万多夫斯基接佩德里妙传，禁区内一脚低射破门，巴萨1-0领先。此后皇马展开疯狂反扑，但巴萨门将特尔施特根表现出色，多次化解险情。</p>
    <p>下半场易边再战，皇马加大了进攻力度。第58分钟，维尼修斯左路突破传中，贝林厄姆后点头球攻门得手，将比分扳为1-1。伯纳乌球场瞬间沸腾。</p>
    <p>第78分钟，皇马获得前场任意球机会。贝林厄姆主罚，皮球划出一道完美的弧线直挂球门死角，特尔施特根鞭长莫及。2-1！贝林厄姆梅开二度！</p>
    <p>最终，皇马以2-1逆转战胜巴萨，取得国家德比的胜利。此役过后，皇马以7分优势领跑积分榜，巴萨的争冠形势变得更加严峻。</p>
    <p>赛后，皇马主帅安切洛蒂盛赞贝林厄姆的表现："他是一位现象级的球员，总是在关键时刻挺身而出。这场胜利对我们来说至关重要。"</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=Spanish%20football%20El%20Clasico%20Real%20Madrid%20vs%20Barcelona%20stadium%20atmosphere%20with%20dramatic%20lighting%2C%20sports%20photography%20style%2C%20warm%20golden%20tones%2C%20dynamic%20composition%2C%20professional%20sports%20journalism%20aesthetic&width=1200&height=600&seq=article-1-cover&orientation=landscape",
    author: "体育观察员",
    publishDate: "2026-08-03",
    views: 86520,
    tags: ["西甲", "国家德比", "皇家马德里", "巴塞罗那", "贝林厄姆"],
    isFeatured: true,
  },
  {
    id: "article-2",
    categoryId: "cat-2",
    title: "湖人98-92勇士！詹姆斯三双带领球队取得关键胜利",
    summary: "NBA常规赛焦点对决，洛杉矶湖人主场迎战金州勇士。勒布朗·詹姆斯贡献三双数据，帮助湖人以98-92击败勇士，取得赛季关键一胜。",
    content: `<p>北京时间2026年8月5日，NBA常规赛迎来一场重头戏，洛杉矶湖人坐镇斯台普斯中心迎战金州勇士。两支球队都是西部季后赛席位的有力竞争者，这场比赛的重要性不言而喻。</p>
    <p>比赛从第一节开始就异常激烈。勇士队库里手感火热，单节命中4记三分，帮助球队取得领先。但湖人队凭借詹姆斯和戴维斯的稳定发挥，紧咬比分。</p>
    <p>下半场，湖人队防守强度明显提升。詹姆斯在攻防两端全面掌控比赛，第三节单节送出5次助攻，彻底盘活了球队的进攻。戴维斯在内线也展现出统治力，多次封盖对手投篮。</p>
    <p>最终，湖人以98-92战胜勇士。詹姆斯全场砍下28分12篮板11助攻的三双数据，戴维斯贡献22分15篮板。勇士方面，库里得到全场最高的31分，但未能带队取胜。</p>
    <p>湖人队主帅表示："这是一场团队胜利，每个人都在防守端做出了贡献。勒布朗一如既往地出色，他是我们的领袖。"</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=NBA%20basketball%20game%20Los%20Angeles%20Lakers%20vs%20Golden%20State%20Warriors%20intense%20action%20on%20court%2C%20dramatic%20arena%20lighting%2C%20sports%20photography%20style%2C%20golden%20and%20purple%20tones%2C%20dynamic%20movement&width=1200&height=600&seq=article-2-cover&orientation=landscape",
    author: "篮球评论员",
    publishDate: "2026-08-05",
    views: 75230,
    tags: ["NBA", "湖人", "勇士", "詹姆斯", "三双"],
    isFeatured: true,
  },
  {
    id: "article-3",
    categoryId: "cat-3",
    title: "张伟丽：目标不止卫冕，要成为UFC史上最伟大的女子选手",
    summary: "UFC女子草量级冠军张伟丽接受专访，畅谈即将到来的卫冕战、训练心得以及对于综合格斗运动在中国发展的展望。",
    content: `<p>在中国综合格斗界，张伟丽的名字已经成为一个传奇。作为UFC女子草量级冠军，她不仅在八角笼中展现了惊人的实力，更用自己的故事激励着无数中国年轻人走上格斗之路。</p>
    <p>即将到来的UFC 310中，张伟丽将迎战前冠军罗斯·娜玛尤纳斯。这被看作是她职业生涯中最具挑战性的卫冕战之一。在接受开体育在线专访时，张伟丽显得信心十足。</p>
    <p>"罗斯是一位非常出色的选手，她的站立打击技术是世界顶级的。但我已经做好了充分的准备，我对自己的地面技术和体能状况非常有信心。"张伟丽说道。</p>
    <p>谈及自己的目标，张伟丽表示："我的目标不仅仅是一次又一次地卫冕冠军，我想成为UFC历史上最伟大的女子选手。我希望当人们谈论女子MMA的时候，第一个想到的就是我的名字。"</p>
    <p>对于综合格斗在中国的发展，张伟丽充满期待："现在越来越多的中国年轻人开始接触MMA，这是非常好的趋势。我希望通过自己的表现，让更多人了解和喜爱这项运动。"</p>
    <p>张伟丽的卫冕战将于北京时间2026年9月15日进行，开体育在线将全程直播这场备受瞩目的冠军争夺战。</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20female%20UFC%20champion%20Zhang%20Weili%20training%20in%20octagon%20with%20dramatic%20lighting%2C%20powerful%20athletic%20pose%2C%20golden%20and%20red%20tones%2C%20professional%20sports%20photography%2C%20championship%20aesthetic&width=1200&height=600&seq=article-3-cover&orientation=landscape",
    author: "格斗前线记者",
    publishDate: "2026-08-01",
    views: 62100,
    tags: ["UFC", "张伟丽", "综合格斗", "MMA", "冠军"],
    isFeatured: true,
  },
  {
    id: "article-4",
    categoryId: "cat-1",
    title: "英超新赛季前瞻：六大豪门转会盘点与夺冠形势分析",
    summary: "2026-2027赛季英超联赛即将拉开帷幕。本文为您深度分析六大豪门的夏季转会操作，预测新赛季的争冠格局。",
    content: `<p>随着夏季转会窗口的关闭，2026-2027赛季英超联赛的格局已经初步明朗。六大豪门在转会市场上的操作，将很大程度上决定新赛季的争冠形势。</p>
    <p><strong>曼城</strong>：作为卫冕冠军，曼城在转会市场上保持了稳健的策略。球队引进了一名顶级中后卫和一名年轻边锋，进一步补强了阵容深度。瓜迪奥拉的球队依然是新赛季的最大热门。</p>
    <p><strong>利物浦</strong>：红军在中场进行了大规模重建，引进了两名技术型中场。克洛普表示对新援非常满意，球队的进攻体系将更加多样化。</p>
    <p><strong>阿森纳</strong>：枪手在锋线上投入重金，签下了一名世界级中锋。这名新援的加入将解决球队上赛季进攻端缺乏终结能力的问题。</p>
    <p>其他三支豪门——切尔西、曼联和热刺——也各自进行了针对性的补强。新赛季的英超联赛注定将是一场精彩纷呈的冠军争夺战。</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=English%20Premier%20League%20stadium%20panoramic%20view%20with%20green%20pitch%20and%20packed%20stands%2C%20dramatic%20evening%20light%2C%20atmospheric%20sports%20photography%2C%20vibrant%20green%20tones%2C%20grand%20scale&width=1200&height=600&seq=article-4-cover&orientation=landscape",
    author: "足球分析师",
    publishDate: "2026-08-04",
    views: 54320,
    tags: ["英超", "转会", "赛季前瞻", "曼城", "利物浦"],
    isFeatured: false,
  },
  {
    id: "article-5",
    categoryId: "cat-5",
    title: "JDG 2-1 T1！LPL赛区时隔两年再夺世界冠军",
    summary: "英雄联盟全球总决赛圆满落幕，LPL赛区头号种子JDG以3-1的大比分击败LCK霸主T1，成功捧起召唤师奖杯。",
    content: `<p>经过一个月的激烈角逐，2026年英雄联盟全球总决赛在万众期待中落下帷幕。LPL赛区头号种子JDG在决赛中展现了超强的实力，以3-1的大比分击败了来自LCK赛区的传奇战队T1。</p>
    <p>决赛五局三胜制的比赛中，JDG从第一局开始就展现了极高的竞技水平。上单选手369在线上压制对手，打野选手Kanavi的节奏掌控堪称完美，中单选手Knight的发挥更是得到了全世界观众的认可。</p>
    <p>T1在第二局扳回一分，展现了这支老牌强队的韧性。但JDG在随后的比赛中调整了战术，连下两城，最终以3-1的总比分锁定胜局。</p>
    <p>这是LPL赛区时隔两年再次夺得全球总决赛冠军，也是JDG队史上的第一座召唤师奖杯。赛后，整个LPL赛区陷入了狂欢。</p>
    <p>JDG队长在赛后采访中表示："这是我们努力了整整一年的结果。感谢所有支持我们的粉丝，这座奖杯属于每一位LPL的观众。"</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=Esports%20League%20of%20Legends%20world%20championship%20final%20stage%20with%20huge%20arena%20crowd%2C%20neon%20lights%2C%20golden%20trophy%2C%20dramatic%20atmosphere%2C%20professional%20esports%20photography%2C%20spectacular%20lighting%20effects&width=1200&height=600&seq=article-5-cover&orientation=landscape",
    author: "电竞观察员",
    publishDate: "2026-07-30",
    views: 156800,
    tags: ["英雄联盟", "全球总决赛", "JDG", "T1", "LPL"],
    isFeatured: true,
  },
  {
    id: "article-6",
    categoryId: "cat-4",
    title: "郑钦文创历史！WTA年终总决赛中国选手首进四强",
    summary: "中国网球新星郑钦文在WTA年终总决赛小组赛中以两胜一负的成绩成功晋级四强，成为首位达成这一成就的中国选手。",
    content: `<p>北京时间2026年8月4日，WTA年终总决赛小组赛全部结束。中国选手郑钦文以两胜一负的战绩从小组出线，成功晋级半决赛，创造了中国网球的历史。</p>
    <p>在小组赛最后一场比赛中，郑钦文面对世界排名第一的斯瓦泰克，展现了极强的竞争力和心理素质。虽然在首盘以4-6告负，但她迅速调整状态，以6-3和6-4连胜两盘，完成逆转。</p>
    <p>"能够成为第一位晋级WTA年终总决赛四强的中国选手，我感到非常自豪。"郑钦文在赛后新闻发布会上表示，"但这只是一个开始，我的目标是走得更远。"</p>
    <p>郑钦文的出色表现获得了国际网坛的广泛关注。多位网球名宿在社交媒体上对她的表现给予了高度评价，称赞她"拥有成为世界第一的全部潜力"。</p>
    <p>半决赛中，郑钦文将对阵另一位世界顶级选手。无论结果如何，她已经在2026赛季书写了属于自己的传奇篇章。</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=Professional%20female%20tennis%20player%20in%20action%20on%20clay%20court%20under%20bright%20sunlight%2C%20powerful%20forehand%20swing%2C%20dramatic%20sports%20photography%2C%20warm%20terracotta%20tones%2C%20dynamic%20athletic%20movement&width=1200&height=600&seq=article-6-cover&orientation=landscape",
    author: "网球深度报道",
    publishDate: "2026-08-04",
    views: 48150,
    tags: ["网球", "WTA", "郑钦文", "年终总决赛", "中国网球"],
    isFeatured: false,
  },
  {
    id: "article-7",
    categoryId: "cat-6",
    title: "F1中国大奖赛前瞻：周冠宇主场作战，能否创造历史？",
    summary: "2026赛季F1中国大奖赛即将在上海国际赛车场拉开帷幕。中国车手周冠宇将主场作战，期待在家乡父老面前创造佳绩。",
    content: `<p>时隔一年，F1中国大奖赛再次回到上海国际赛车场。作为F1赛历上最具看点的一站比赛，中国大奖赛不仅是车迷的盛宴，更是中国赛车运动的展示窗口。</p>
    <p>对于中国车手周冠宇来说，这站比赛的意义非同寻常。作为F1历史上第一位中国正式车手，他将在主场观众面前展示自己的实力。"每次在主场作战，我都能感受到来自全国各地车迷的支持和鼓励。这种感觉是独一无二的。"周冠宇在赛前采访中说道。</p>
    <p>本赛季周冠宇的表现稳步提升，多次在积分区内完赛。在最近两站比赛中，他都成功进入了Q3排位赛。车队对他的进步给予了高度评价。</p>
    <p>本站比赛的最大看点之一是周冠宇与七冠王汉密尔顿的正面对决。两位车手在上赛季就有过多次精彩的轮对轮较量，本赛季他们的竞争更加激烈。</p>
    <p>中国大奖赛将于2026年8月16日正式开赛，开体育在线将全程直播排位赛和正赛。</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=Formula%201%20racing%20car%20on%20Shanghai%20International%20Circuit%20track%20at%20high%20speed%2C%20dramatic%20motion%20blur%2C%20evening%20golden%20light%2C%20professional%20motorsport%20photography%2C%20dynamic%20racing%20atmosphere&width=1200&height=600&seq=article-7-cover&orientation=landscape",
    author: "赛车前线",
    publishDate: "2026-08-06",
    views: 38900,
    tags: ["F1", "中国大奖赛", "周冠宇", "赛车", "上海"],
    isFeatured: false,
  },
  {
    id: "article-8",
    categoryId: "cat-2",
    title: "广东宏远vs辽宁本钢经典对决回顾：CBA最精彩的时代",
    summary: "回顾广东宏远与辽宁本钢在CBA历史上的经典对决，从易建联时代到新一代球员的崛起，两支球队共同书写了CBA最辉煌的篇章。",
    content: `<p>在中国篮球的历史上，广东宏远和辽宁本钢之间的对决，无疑是CBA联赛最具看点的经典之战。两支球队各自代表着中国篮球的最高水平，他们之间的每一次交锋都是一场视觉盛宴。</p>
    <p>从易建联领衔的广东王朝时代，到郭艾伦、赵继伟带领辽宁崛起的新时代，两支球队在近十年的CBA赛场上贡献了无数经典瞬间。无论是常规赛的激烈角逐，还是总决赛的巅峰对决，每一次"粤辽大战"都让球迷回味无穷。</p>
    <p>如今，随着新一代球员的成长，两支球队的阵容都发生了变化。广东宏远在年轻化重建的道路上稳步前进，而辽宁本钢则保持了核心阵容的稳定性。新赛季即将到来，两支球队的较量令人期待。</p>
    <p>值得一提的是，2026年8月10日，广东宏远将在主场迎战辽宁本钢，这将是新赛季开始前的一场重要热身赛。</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=CBA%20Chinese%20basketball%20intense%20game%20between%20Guangdong%20and%20Liaoning%20in%20packed%20arena%2C%20dramatic%20sports%20photography%2C%20red%20and%20blue%20team%20colors%2C%20dynamic%20basketball%20action%2C%20passionate%20crowd&width=1200&height=600&seq=article-8-cover&orientation=landscape",
    author: "篮球档案馆",
    publishDate: "2026-08-02",
    views: 31200,
    tags: ["CBA", "广东宏远", "辽宁本钢", "经典对决", "中国篮球"],
    isFeatured: false,
  },
];